// extracted by mini-css-extract-plugin
export default {"main":"styles_main__tNJQq","main__nav":"styles_main__nav__15ztQ"};